import { useEffect, useCallback } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1283778677132640'
let pixelLoaded = false

function loadPixelScript() {
  if (pixelLoaded) return
  pixelLoaded = true

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
  }, [])

  const trackAddToCart = useCallback(() => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Grandma & Me: Memory Tickets',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  }, [])

  return { trackAddToCart }
}
